import React, {useEffect, useCallback, useState} from 'react';
import {Line} from 'react-chartjs-2';
import {Chart} from 'chart.js/auto';
import {getHarvestTimeEntriesLastPeriod} from "../../utilities/harvestAPI";
import keycloak from "../../Keycloak";
import {selectedFilterTypeValue} from "./ServiceRequestDashboard";
import Card from "@mui/material/Card";

console.log(Chart);
function LineChart(){
    const [harvestTimeEntries, setHarvestTimeEntries] = useState([]);
    const cardStyle = {
        borderRadius: 15,
    };
    const labelsWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const hoursWeek =[0.0,0.0,0.0,0.0,0.0,0.0,0.0];

    let labelsMonth =[];
    let hoursMonth= [];

    let labelsLastMonth =[];
    let hoursLastMonth= [];

    let hours =[];
    let labels = [];
    let periodBack = 0;
    let filterType = 1;
    //let filterType = selectedFilterTypeValue
    console.log("Selected filter type value ", selectedFilterTypeValue);
    const callGetTimeEntries = useCallback(() => {
        let projectId = localStorage.getItem("serviceRequestProjectId")
        console.log(projectId)
        getHarvestTimeEntriesLastPeriod(projectId, periodBack, filterType, keycloak.token)
            .then((timeEntries) => {
                setHarvestTimeEntries(timeEntries);
                console.log("time " , timeEntries);
            })
            .catch((e) => {
                console.log(e)
            })
    }, [setHarvestTimeEntries, filterType, periodBack])

    useEffect(() => {
        callGetTimeEntries();
    }, [callGetTimeEntries, filterType])

    if(filterType === 0) {
        harvestTimeEntries.forEach((item) => {
            let date = new Date(item.date);
                if (date.getFullYear() >= 2022) {
                    if (date.getDay() === 1) {
                        hours[0] += item.hours;
                    }
                    if (date.getDay() === 2) {
                        hours[1] += item.hours;
                    }
                    if (date.getDay() === 3) {
                        hours[2] += item.hours;
                    }
                    if (date.getDay() === 4) {
                        hours[3] += item.hours;
                    }
                    if (date.getDay() === 5) {
                        hours[4] += item.hours;
                    }
                    if (date.getDay() === 6) {
                        hours[5] += item.hours;
                    }
                    if (date.getDay() === 7) {
                        hours[6] += item.hours;
                    }
                }
            })

            hours = hoursWeek;
            labels = labelsWeek;
        }else if (filterType === 1) {
            harvestTimeEntries.forEach((item) =>{
                hoursMonth.push(item.hours);
                labelsMonth.push(item.date);
            })
            hours = hoursMonth;
            labels = labelsMonth;
        }
        else{
            harvestTimeEntries.forEach((item) =>{
                hoursLastMonth.push(item.hours);
                labelsLastMonth.push(item.date);
            })
            hours = hoursLastMonth;
            labels = labelsLastMonth;
        }

        const chartData = {
            options: {
                responsive: true,
                plugins: {
                    legend:{
                        labels:{
                            boxHeight: 2.5,
                        }
                    }
                },
                scales: {
                    x: {
                        grid: {
                            display: false,
                        },
                        ticks: {
                            display: true,
                        },
                    },
                    y: {
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: 'Hours Utilised',
                        },
                        grid: {
                            display: true,
                            z: 1,
                        },
                    },
                },
            },
            plugins: {
                legend: {
                    display: false,
                },
            },
            data: {
                labels: labels,
                datasets: [
                    {
                        label: "Time utilisation trend",
                        data: hours,
                        fill: true,
                        backgroundColor: '#fff2ea',
                        tension: 0.325,
                        borderColor: "#F79016",
                        borderWidth: 4,
                        pointStyle: 'dot',
                        pointRadius: 4,
                        pointBackgroundColor: "black",
                        pointHoverRadius: 6,
                        pointBorderColor: "white",
                    },
                ],
            },
        };


        return (<Card style={cardStyle} className={"lineChartCard"} data-testid={"ServiceRequestChart"} justifyContent={"center"}>
            <Line {...chartData} />
        </Card>);
    }
    export default LineChart;